import { Search } from "@mui/icons-material";

export const SearchBox = ({placeholder,value,onChange,disabled = false, customStyle = ""}) => {
  return (
    <div
      className={`flex items-center gap-2 border border-gray-500 rounded-xl bg-white px-2 py-1 md:w-80 ${customStyle}`}
    >
      <Search size={16} className="opacity-70 text-gray-500" />
      <input
        placeholder={placeholder}
        className="bg-transparent outline-none text-sm flex-1 text-black"
        value={value}
        disabled={disabled}
        onChange={onChange}
      />
    </div>
  );
};
